import React, { useMemo, Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TYPE from "../../../../../constant/TYPE";
import Title from "./Title";
import ClosePopup from "../popup/ClosePopup";
import ClosePopupGlobal from "../../presentationalGlobal/popup/ClosePopup";
import AnsweringInfo from "./answeringInfo/AnsweringInfo";
import { loadQuestion } from "../../../../../api/questionAPI";
import { useAmplitude } from "../../../../../hooks";
import { useHistory } from "react-router-dom";
import { URL } from "../../../../../constant";

const Header = ( props ) => {

  const user = useSelector( state => state.user );
  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const { setAmplitudeLog } = useAmplitude();
  const questionData = useSelector(state => state.amplitudeLogData.question_data);
  const history = useHistory();

  const {
    Closer,
    children,
    ...PROPS
  } = props;

  const CLOSE_POPUP = useMemo( () => {
    return TYPE.CHANNEL.GLOBAL01 === user.info.channelCode && TYPE.ENTRY_TYPE.GLOBAL01 === user.info.entryType ? ClosePopupGlobal : ClosePopup;
  }, [ user.info.channelCode, user.info.entryType ] );

  const close = () => {
    loadQuestion( { progressCode : TYPE.ANSWERING_QUESTIONS_PROGRESS.USER_CLOSE } );
    setAmplitudeLog({
      eventName: {
        name: '학습문항풀이 이탈',
        event: {
          "학습유형": '',
          "소주제이름": questionData.stgNm,
          "커리큘럼그룹": questionData.thmaNm,
          "커리큘럼명": questionData.stepNm,
          "소주제코드": questionData.stgCd,
          "문항코드": questionData.qstCd,
          "문항노출순서": `${answeringQuestions.answeringCount}/${questionData.totQstCt}`
        }
      }
    });
    // history.goBack();

    // 개념확인 팝업으로 페이지이동 분기처리
    if(answeringQuestions.learningType === TYPE.LEARNING.COURSE) {
      history.push(URL.COURSE_LEARNING.LIST);
    } else {
      history.goBack();
    }
  };

  return (
    <div className="header dark">
      <div className="inner">
        <div className="headerBox">
          <div className="headerBox_head">
            <Title>{ answeringQuestions.data.stgNm }</Title>
            { 
              (TYPE.CHANNEL.GLOBAL01 === user.info.channelCode && TYPE.LEARNING.COURSE === answeringQuestions.learningType) ? 
              <button onClick={close} className="btn-close-wrap">닫기</button> : 
              <Closer><CLOSE_POPUP><button className="btn-close-wrap">닫기</button></CLOSE_POPUP></Closer>
            }
          </div>
          <div className="headerBox_body">
            <AnsweringInfo { ...PROPS } />
          </div>
        </div>
      </div>
    </div>
  );

};

Header.defaultProps = {
  Closer : Fragment
};

export default Header;
